import Container from 'react-bootstrap/Container';
import ServicesGetAll from '../services/ServicesGetAll';

function Services() {
  return (
    <div>
      <Container>
        <ServicesGetAll />
      </Container>
    </div>
  );
}

export default Services;